export const ROUTE_BASE_URL = "/";

export const ROUTE_LOGIN = "/login";
export const ROUTE_LOGIN_RESET_PASSWORD = "/login/reset-password/:token/:email";

export const ROUTE_DASHBOARD = "/dashboard";

export const ROUTE_SEARCH = "/search";
export const ROUTE_SEARCH_ARTICLE = "/search/article/:article_id";
export const ROUTE_SEARCH_ARTICLE_CONTENT =
  "/search/article/:article_id/content";
export const ROUTE_SEARCH_ARTICLE_SUMMARY =
  "/search/article/:article_id/summary";
export const ROUTE_SEARCH_ARTICLE_COMMENTS =
  "/search/article/:article_id/comments";
export const ROUTE_SEARCH_ARTICLE_RELATED_ARTICLES =
  "/search/article/:article_id/related-articles";
export const ROUTE_SEARCH_ARTICLE_CHATBOT =
  "/search/article/:article_id/chatbot";
export const ROUTE_SEARCH_TRACKED_SEARCH = "/search/:tracked_search_id";

export const ROUTE_READING_LISTS = "/reading-lists";
export const ROUTE_READING_LISTS_LIST = "/reading-lists/:reading_list_id";

export const ROUTE_TASK_MANAGER = "/task-manager";
export const ROUTE_TASK_MANAGER_MY_TASKS = "/task-manager/my-tasks";
export const ROUTE_TASK_MANAGER_MY_REGFLOWS = "/task-manager/my-regflows";
export const ROUTE_TASK_MANAGER_ALL_REGFLOWS = "/task-manager/all-regflows";
export const ROUTE_TASK_MANAGER_REGFLOW = "/task-manager/regflow";
export const ROUTE_TASK_MANAGER_REGFLOW_REGFLOW_ID =
  "/task-manager/regflow/:regflow_id";
export const ROUTE_TASK_MANAGER_DOCUMENT_REGFLOWS =
  "/task-manager/document-regflows/:article_id";
export const ROUTE_TASK_MANAGER_READING_LIST_REGFLOWS =
  "/task-manager/reading-list-regflows/:reading_list_id";

export const ROUTE_DOCUMENT_MANAGEMENT = "/document-management";
export const ROUTE_DOCUMENT_MANAGEMENT_DOCUMENT_ID =
  "/document-management/:documentId";
export const ROUTE_DOCUMENT_MANAGEMENT_NEW_DOCUMENT =
  "/document-management/new-document";

export const ROUTE_NEWSLETTERS = "/newsletters";
export const ROUTE_NEWSLETTERS_NEWSLETTER_ID = "/newsletters/:newsletterId";
export const ROUTE_NEWSLETTERS_NEWSLETTER_ID_PREVIEW_ID =
  "/newsletters/:newsletterId/:previewId";

export const ROUTE_USER_GUIDE = "/user-guide";
export const ROUTE_USER_GUIDE_PRIVACY = "/user-guide/privacy";

export const ROUTE_SETTINGS = "/settings";
export const ROUTE_SETTINGS_MY_SETTINGS = "/settings/my-settings";
export const ROUTE_SETTINGS_TOPICS = "/settings/topics";
export const ROUTE_SETTINGS_IMPACTED_PARTIES = "/settings/impacted-parties";
export const ROUTE_SETTINGS_USERS = "/settings/users";
export const ROUTE_SETTINGS_LEGAL_ENTITIES = "/settings/legal-entities";
